<template>
  <div class="page">
    <div class="panel">
      <van-icon v-if="type == 'success'" name="checked" class="success-icon" />
      <van-icon v-if="type == 'warning'" name="warning" class="warning-icon" />
      <div class="info-title">{{ title }}</div>
      <div class="info-desc">{{ content }}</div>
    </div>
    <div v-if="showReview && submitCount > 0 && mode != 'mgrEdit'" class="link" @click="toHistory">查看历史提交记录 ({{ submitCount }})</div>
  </div>
</template>

<script>
import request from "@/utils/RequestWithVant";
import uuid from "@/utils/UUID";

export default {
  props: ["id"],
  data() {
    return {
      type: "",
      title: "",
      content: "",
      showReview: false,
      submitCount: 0,
      mode: "",
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.mode = this.$route.query.mode;
    let info = JSON.parse(localStorage.getItem("idata_info"));
    if (info) {
      if (info.code == "6600204") {
        // 已提交
        this.type = "success";
        this.title = "已完成提交";
        this.content = "感谢您的参与";
        document.title = "完成";
      } else if (info.code == "6600261") {
        // 已提交
        this.type = "success";
        this.title = "已完成提交";
        this.content = info.message;
        document.title = "完成";
      } else {
        this.type = "warning";
        this.title = "抱歉";
        this.content = info.message;
      }
      // 6600202 提交人次已达上限 || 6600204 您已完成提交，无需重复提交 || 6600261 数据更改成功
      // if (
      //   "6600202" == info.code ||
      //   "6600204" == info.code ||
      //   "6600261" == info.code
      // ) {
      this.showReview = true;
      if (this.mode != "mgrEdit") {
        this.getSubmitCount();
      }
      // }
    }
  },
  methods: {
    getSubmitCount() {
      request
        .get(
          "./api/collect/getSubmitCount/" +
            this.id +
            "?clientId=" +
            this.getClientId()
        )
        .then((res) => {
          this.submitCount = res.data;
        });
    },
    toHistory() {
      this.$router.push({
        path: "/history/" + this.id,
      });
    },
    getClientId() {
      let clientId = localStorage.getItem("idata_client_id");
      if (!clientId) {
        clientId = uuid();
        localStorage.setItem("idata_client_id", clientId);
      }
      return clientId;
    },
  },
};
</script>
<style scoped>
.page {
  height: 100%;
}
.panel {
  text-align: center;
}
.success-icon {
  font-size: 5rem;
  color: #07c160;
  margin-top: 15vh;
}
.warning-icon {
  font-size: 5rem;
  color: #1989fa;
  margin-top: 15vh;
}
.info-title {
  margin-top: 1.5rem;
  font-size: 1.3rem;
}
.info-desc {
  margin-top: 0.6rem;
  color: #969799;
}
.link {
  position: absolute;
  bottom: 1rem;
  left: calc(50% - 6rem);
  width: 12rem;
  text-align: center;
  color: #969799;
  text-decoration: underline;
  cursor: pointer;
}
</style>